import { mapGetters } from 'vuex';
import vuexViewportMixin from 'framework/vuex/modules/viewport/mixin';
import vuexScrollMixin from 'framework/vuex/modules/scroll/mixin';
import isMobileMixin from 'framework/mixins/is-mobile';


window.googleRecaptchaCallback = function() {
    globals.state.googleRecaptchaLoaded = true;
};


export default {
    mixins: [
        vuexViewportMixin,
        vuexScrollMixin,
        isMobileMixin,
    ],
    el: '.skel',
    data() {
        return {
            isStyleguide: false,
            globals,
            transitionPage: null,
            transitionToPage: null,
            transitionFromPage: null,
        };
    },
    computed: {
        ...mapGetters(['router', 'pageType']),
        transitionName() {
            let result;

            switch (this.transitionPage) {
                case 'page-home':
                case 'page-location':
                    result = `trs-${ this.transitionPage }`;
                    break;
                default:
                    result = 'trs-simple-fade';
                    break;
            }

            return result;
        },
    },
    methods: {
        afterRouteLeave() {
            this.transitionPage = this.transitionToPage;
        },
        afterRouteEnter() {
            this.transitionPage = null;
        },
    },
    watch: {
        $route: {
            handler(to, from) {
                if (window.styleguide) {
                    this.isStyleguide = true;
                }

                this.transitionToPage = to.meta.page;
                this.transitionFromPage = from.meta.page;

                this.transitionPage = this.transitionFromPage;
            },
        },
    },
    mounted() {
        if (window.styleguide) {
            this.isStyleguide = true;
        }
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/base/app-root.js